import React from 'react'

const AirlineInfo = ({ info, modalFlag = false }) => {
  const infoView = (
    <React.Fragment>
      {info.map((inf, index) => (
        <div className="fs-13 mt-1">
          <div className="fw-700">{inf.Name}</div>
          <If condition={inf['Contact number:'] || inf['Website:']}>
            <div className="">
              {' '}
              Contact number:{' '}
              <a href={`tel:${inf['Contact number:']}`}>{inf['Contact number:'] || '--'}</a>
            </div>
            <If condition={inf['Website:']}>
              <div>
                {' '}
              Website:
                <a
                  className="c-secondary-500"
                  href={inf['Website:']}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {(inf['Website:'] && ' click here') || '--'}
                </a>
              </div>
            </If>
          </If>
          <If condition={!inf['Contact number:'] && !inf['Website:']}>
            <div className=""> Please contact the corresponding airline </div>
          </If>
        </div>
      ))}
    </React.Fragment>
  )

  return <React.Fragment>{infoView}</React.Fragment>
}

export default AirlineInfo
